import { Component, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { I18NService, UserService, Versions, VersionsService } from '@socrates/socrates-shared';
import { User } from '@socrates/common';

@Component({
	selector: 'login-component',
	templateUrl: 'login.component.html',
	standalone: false,
})
export class LoginComponent implements OnInit {
	private _invalidLogin = false;
	private _logoutReason = false;
	username: string;
	password: string;
	private _versions: Versions;
	readonly submitting = signal(false);

	constructor(
		private userService: UserService,
		public router: Router,
		private versionsService: VersionsService
	) {}

	ngOnInit(): void {
		if (window.history.state.logoutMessage) {
			this._logoutReason = true;
			window.history.replaceState({}, '', window.location.href);
		}
		this.versionsService.loadVersions().then((versions: Versions) => {
			this._versions = versions;
		});
	}

	async onSubmit(loginForm: any): Promise<void> {
		this._logoutReason = false;
		this.username = loginForm.uname;
		this.password = loginForm.pword;
		this._invalidLogin = false;
		this.submitting.set(true);
		try {
			const user: User = await this.userService.authenticateUser({
				username: this.username.trim(),
				password: this.password.trim(),
			});
			this.submitting.set(false);
			if (user) {
				if (this.userService.detouredRoute) {
					this.userService.rerouteIfNeeded();
				} else {
					this.router.navigate(['/dashboard']);
				}
			}
		} catch (error: any) {
			this.submitting.set(false);
			if (error?.status === 412) {
				this.router.navigate(['/newLogin'], { queryParams: { username: this.username.trim() } });
			} else {
				this._invalidLogin = true;
			}
		}
	}

	forgotPassword(loginForm: any): void {
		this.router.navigate(['/passwordReset'], { queryParams: { username: loginForm.password } });
	}

	getMessage(key: string): string {
		return I18NService.getMessage(key);
	}

	get invalidLogin(): boolean { return this._invalidLogin; }
	get logoutReason(): boolean { return this._logoutReason; }
	get versions(): Versions { return this._versions; }
}
